// extracted by mini-css-extract-plugin
module.exports = {"entered":"transition-scrollScreenshotTransition-module--entered--3j5Mi","exiting":"transition-scrollScreenshotTransition-module--exiting--IzAqL"};